import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IndicadoresVivosVModel } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { AsignacionDistribucionService } from '../../services/asignacion-y-distribucion.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';

@Component({
  selector: 'app-asignacion-y-distribucion-upload-csv',
  templateUrl: './asignacion-y-distribucion-upload-csv.component.html',
  styleUrls: ['./asignacion-y-distribucion-upload-csv.component.css']
})

export class AsignacionDistribucionCSVComponent implements OnInit {

  titulo = 'Carga de Asignación y Distribución de Pesos a Variables';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  modulo: any = {};


  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  cmbOpciones: { clave: number; valor: string; }[];

  cmbOpcionesV2: any[] = [
    { clave: true, valor: 'SI' },
    { clave: false, valor: 'NO' }
  ]

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private catalogo: CatalogoService,
    private _serviciosCRUD: AsignacionDistribucionService,
  ) { }

  ngOnInit() {

    this.formulario = this.fb.group({
      multipart: ['', [Validators.required]],
    });

    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGriAsignacionDistribucion();

    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();

    this.formulario.get('multipart').valueChanges
      .subscribe((resp) => {
        this.getFormValidationErrors();
      });

  }

  /** FUNCIONES */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        headerName: 'Tipo de Vendedor',
        field: this.modelGrid.descripcionTipoVendedor,
        filter: true,
        width: 350,
        sortable: true
      },
      {
        headerName: 'Tipo de Variable',
        field: this.modelGrid.descripcionVariable,
        filter: true,
        width: 350,
        sortable: true
      },
      {
        headerName: 'Peso %',
        field: this.modelGrid.valorPeso,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Fecha Inicio',
        field: this.modelGrid.fechaInicio,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Fecha Fin',
        field: this.modelGrid.fechaFin,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        filter: true,
        width: 600,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._serviciosCRUD.procesarCsv(this.setFormData(this.formulario.value)),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      console.log("enviarFormulario()", res);
      // debugger
      this.mostrarFormulario = true;
      for (let i = 0; i < res.length; i++) {
        res[i].fechaInicio = res[i].fechaInicio.split('T')[0].split('-').reverse().join('-');
        res[i].fechaFin = res[i].fechaFin.split('T')[0].split('-').reverse().join('-');
      }
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {

    for (let i = 0; i < this.rowData.length; i++) {
      this.rowData[i].fechaFin = this.rowData[i].fechaFin ? this.rowData[i].fechaFin.split('-').reverse().join('-') + 'T00:00:00' : '';
      this.rowData[i].fechaCarga = this.rowData[i].fechaCarga ? this.rowData[i].fechaCarga.split('-').reverse().join('-') + 'T00:00:00' : '';
      this.rowData[i].fechaInicio = this.rowData[i].fechaInicio ? this.rowData[i].fechaInicio.split('-').reverse().join('-') + 'T00:00:00' : '';
    }

    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado?',
        text: '',
        action: 'Guardar',
        funcion: this._serviciosCRUD.saveCsv(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      this.downloadDataCsv();
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['COD.TIPO DE VENDEDOR', 'FECHA_INICIO', 'FECHA_FIN', 'COD. VARIABLE', 'PESO DE VARIABLE']];
    const data: any[] = [
      { 'anio': '18', 'mes': '1/1/2024', 'vendedor': '31/1/2024', 'cliente': '43', 'articulo': '30' }
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['asignacionId', 'tipoAsignacion', 'fechaInicio', 'fechaFin', 'tipoVendedorId', 'usuarioCarga', 'fechaCarga', 'variableId', 'valorPeso', 'Estado', 'Linea', 'Error']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.correct) {
        data.push(
          {
            asignacionId: (e.asignacionId === undefined) ? '' : e.asignacionId,
            tipoAsignacion: (e.tipoAsignacion === undefined) ? '' : e.tipoAsignacion,
            fechaInicio: (e.fechaInicio === undefined) ? '' : e.fechaInicio,
            fechaFin: (e.fechaFin === undefined) ? '' : e.fechaFin,
            tipoVendedorId: (e.tipoVendedorId === undefined) ? '' : e.tipoVendedorId,
            usuarioCarga: (e.usuarioCarga === undefined) ? '' : e.usuarioCarga,
            fechaCarga: (e.fechaCarga === undefined) ? '' : e.fechaCarga,
            variableId: (e.variableId === undefined) ? '' : e.variableId,
            valorPeso: (e.valorPeso === undefined) ? '' : e.valorPeso,
            estado: (e.correct) ? 'CORRECTO' : 'INCORRECTO',
            linea: (e.error === undefined) ? '' : e.error.linea,
            errorCampo: (e.error === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });
    let name: string = "REGISTRO_ERRORES.csv";
    this._util.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  setCodigoArticulo({ codigoArticulo, contenedor }) {
    if (codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") {
      return `${codigoArticulo}/${contenedor}`
    } else {
      if (codigoArticulo !== undefined) {
        return `${codigoArticulo}`;
      } else {
        return '';
      }
    }
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

}
